<template>
  <div>
    <v-layout :key="index" v-show="isVisible(prezzo)" v-for="(prezzo, index) in currentPrezzo" column>
      <v-flex xs12>
        <h5>Livello {{ prezzo.livello }}</h5>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12 md2 v-if="type == 'var'">
          <v-select :items="priceType" v-model="prezzo.tipo" @change="changeType" label="Prezzo fisso/percentuale" :disabled="disabled"></v-select>
        </v-flex>
        <v-flex xs12 md5>
          <v-text-field
            name="input-1"
            v-money="moneyMask"
            :label="soloMetti ? 'Prezzo' : 'Prezzo metti'"
            dark
            v-model.lazy="prezzo.prezzop"
            :prepend-icon="prezzo.tipo != 2 ? 'euro_symbol' : 'fa-percent'"
            :disabled="disabled"
          ></v-text-field>
        </v-flex>
        <v-flex v-if="pTogli" xs12 md5>
          <v-text-field
            name="input-2"
            label="Prezzo togli"
            dark
            v-money="moneyMask"
            v-model.lazy="prezzo.prezzom"
            :prepend-icon="prezzo.tipo != 2 ? 'euro_symbol' : 'fa-percent'"
            :disabled="disabled"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
/**
 * Gestione del prezzo con tipo ( fisso/perc ) e livelli
 * @module components/common/PriceEditor
 */
export default {
  name: 'priceEditor',
  data: function() {
    return {
      currentPrezzo: [],
      priceType: [
        { text: 'Fisso', value: 1 },
        { text: 'Percentuale', value: 2 },
        { text: 'Imposto', value: 3 }
      ],
      moneyMask: {
        decimal: ',',
        thousands: '.',
        precision: 2
      }
    }
  },
  /**
   * @prop value {array} - Array dei prezzo dell'oggetto
   * @prop type {string} - Tipo di prezzo ( prod / var )
   * @prop listinoMenu {string} - Indica se il listino da utilizzare
   * deve essere preso dal menu oppure quello globale
   * @prop disabled {boolean} - Se true readonly
   * @prop soloMetti {boolean} - Il prezzo togli verra nascosto
   */
  props: ['value', 'type', 'listinoDaMenu', 'disabled', 'soloMetti'],

  methods: {
    parse(i, pm) {
      this.currentPrezzo[i][pm] = utils.toNumeral(this.currentPrezzo[i][pm]).convert()
    },
    format(i, pm) {
      this.currentPrezzo[i][pm] = utils.toNumeral(this.currentPrezzo[i][pm]).toShow()
      this.$emit('setprice', this.currentPrezzo)
    },
    isVisible(prezzo) {
      return prezzo.listino == this.listino && prezzo.when == this.type && prezzo.livello <= this.price_level
    },
    changeType() {
      this.$emit('setprice', this.currentPrezzo)
    },
    init() {
      let newPrices = []

      for (let i = 1; i <= this.price_level; i++) {
        let neededPrice = this.value.find(
          prezzo => prezzo.listino == this.listino && prezzo.when == this.type && prezzo.livello == i && prezzo.when == this.type
        )

        if (!neededPrice) {
          newPrices.push({
            valuta: 'EUR',
            prezzop: utils.toNumeral('0').toShow(),
            prezzom: utils.toNumeral('0').toShow(),
            main: i == 1,
            when: this.type,
            listino: this.listino,
            livello: i,
            tipo: 1
          })
        }
      }

      this.currentPrezzo = this.value
        .map(oldPrice => {
          return Object.assign({}, oldPrice, {
            prezzop: utils.toNumeral(oldPrice.prezzop).toShow(),
            prezzom: utils.toNumeral(oldPrice.prezzom).toShow()
          })
        })
        .concat(newPrices)

      this.$emit('setprice', this.currentPrezzo)
    }
  },
  watch: {
    listino(oldV, newV) {
      if (oldV != newV) this.init()
    }
  },
  computed: {
    price_level() {
      return this.$store.getters.User.settings.price_level
    },
    listino() {
      return this.listinoDaMenu || this.$store.getters.currentListino
    },
    pTogli() {
      return !this.soloMetti
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="stylus">
.priceContainer
  margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// src/components/common/PriceEditor.vue